module.exports = __webpack_public_path__ + "static/media/isdoctorplan-spine-pain2@3x.c0b635a5.png";